import React from 'react';
import Moment from 'react-moment';
import { Link } from 'react-router-dom';
import { object } from 'prop-types';
import { createMarkup } from '../../utils/utils';

const propTypes = {
  article: object.isRequired,
};
const defaultProps = {
  article: {},
};

const FaqLastUpdateItem = ({ article }) => (
  <div className="faq-last-update-item">
    <div className="faq-last-update-item-time">
      <Moment format="DD.MM.YYYY" unix>
        {article.updated}
      </Moment>
      &nbsp;<span className="font-weight-bolder"> · </span>
      <Moment format="LT" unix>
        {article.updated}
      </Moment>
    </div>
    <Link to={'/' + article.path} className="faq-last-update-item-link">
      {article.title}
    </Link>

    <div dangerouslySetInnerHTML={createMarkup(article.preview)} />
  </div>
);

FaqLastUpdateItem.propTypes = propTypes;
FaqLastUpdateItem.defaultProps = defaultProps;

export default FaqLastUpdateItem;
